import { render } from "./CompConsonantTable.vue?vue&type=template&id=efc97536&scoped=true"
import script from "./CompConsonantTable.vue?vue&type=script&lang=js"
export * from "./CompConsonantTable.vue?vue&type=script&lang=js"

import "./CompConsonantTable.vue?vue&type=style&index=0&id=efc97536&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efc97536"]])

export default __exports__